import React from 'react';
import { ShieldCheck, Bug, Award, FileText, Scale, Leaf } from 'lucide-react';
import { certifications } from '../../data/mock';

const iconMap = {
  ShieldCheck: ShieldCheck,
  Bug: Bug,
  Award: Award,
  FileText: FileText,
  Scale: Scale,
  Leaf: Leaf,
};

export const WhyNaviton = () => {
  return (
    <section className="py-24 bg-slate-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Content */}
          <div>
            <span className="inline-block px-4 py-1.5 rounded-full bg-navy-100 text-navy-700 text-sm font-medium mb-4">
              Why Choose Us
            </span>
            <h2 className="text-4xl md:text-5xl font-bold text-navy-900 mb-6">
              Trusted Partner for Global Trade
            </h2>
            <p className="text-xl text-slate-600 mb-8 leading-relaxed">
              With deep expertise in international import and export trade, 
              we ensure your products move seamlessly between Australia and global markets with confidence, 
              compliance, and care.
            </p>

            <div className="space-y-6">
              <div className="flex items-start gap-4">
                <div className="p-3 rounded-xl bg-teal-100 flex-shrink-0">
                  <ShieldCheck className="h-6 w-6 text-teal-600" />
                </div>
                <div>
                  <h3 className="text-lg font-semibold text-navy-900 mb-1">
                    Compliance Excellence
                  </h3>
                  <p className="text-slate-600">
                    Full compliance with Australian import and export regulations and 
                    international trade requirements.
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="p-3 rounded-xl bg-amber-100 flex-shrink-0">
                  <Award className="h-6 w-6 text-amber-600" />
                </div>
                <div>
                  <h3 className="text-lg font-semibold text-navy-900 mb-1">
                    Quality Assurance
                  </h3>
                  <p className="text-slate-600">
                    Rigorous quality control at every stage from sourcing 
                    to final delivery.
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="p-3 rounded-xl bg-emerald-100 flex-shrink-0">
                  <Leaf className="h-6 w-6 text-emerald-600" />
                </div>
                <div>
                  <h3 className="text-lg font-semibold text-navy-900 mb-1">
                    Sustainable Practices
                  </h3>
                  <p className="text-slate-600">
                    Commitment to environmentally responsible sourcing and 
                    sustainable trade practices.
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Certifications Grid */}
          <div className="grid grid-cols-2 gap-4">
            {certifications.map((cert, index) => {
              const Icon = iconMap[cert.icon];
              return (
                <div
                  key={cert.title}
                  className={`p-6 rounded-2xl bg-white border border-slate-200 hover:border-teal-300 hover:shadow-lg transition-all duration-300 ${
                    index === 0 || index === 5 ? 'col-span-2' : ''
                  }`}
                >
                  <Icon className="h-8 w-8 text-navy-900 mb-3" />
                  <h4 className="font-semibold text-navy-900 mb-2">{cert.title}</h4>
                  <p className="text-sm text-slate-600">{cert.description}</p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};
